
// import React, { useState, useEffect } from "react";
// import { Select, Button, Card, Typography, Table, message, Spin } from "antd";
// import { SendOutlined } from "@ant-design/icons";
// import ApiService from "../EOLReportApi/ReportApiService";
// import "antd/dist/reset.css";

// const { Option } = Select;
// const { Title } = Typography;

// const HourlyProductionReport = () => {
//   const [lines, setLines] = useState([]);
//   const [operations, setOperations] = useState([]);
//   const [line, setLine] = useState("");
//   const [operation, setOperation] = useState("");
//   const [produced, setProduced] = useState(0);
//   const [target, setTarget] = useState(0);
//   const [tableData, setTableData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // 🔹 Fetch dropdown data on mount
//   useEffect(() => {
//     const fetchDropdowns = async () => {
//       try {
//         const lineData = await ApiService.getLines();
//         const operationData = await ApiService.getOperations();
//         setLines(lineData);
//         setOperations(operationData);
//       } catch (err) {
//         message.error("Error loading dropdown data");
//         console.error(err);
//       }
//     };
//     fetchDropdowns();
//   }, []);

//   // 🔹 Load report data
//   const handleLoad = async () => {
//     if (!line) {
//       message.warning("Please select a Line!");
//       return;
//     }

//     setLoading(true);
//     try {
//       // ✅ If operation is empty, don't pass it
//       const res = operation
//         ? await ApiService.getMasterOperationsCount(line, operation)
//         : await ApiService.getMasterOperationsCount(line);

//       if (res && res.status) {
//         const stats = res.data?.summary?.line_statistics?.[line];
//         if (stats) {
//           setProduced(stats["producedPCS(device_id)"] || 0);
//           setTarget(stats["count"] || 0);
//           setTableData(res.data?.master_operations || []);
//         } else {
//           setProduced(0);
//           setTarget(0);
//           setTableData([]);
//           message.info("No data found for this line.");
//         }
//       } else {
//         message.error("No data found for selected filters.");
//       }
//     } catch (err) {
//       console.error("Error loading data:", err);
//       message.error("Failed to load data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 🔹 Table Columns
//   const columns = [
//     { title: "Device ID", dataIndex: "device_id", align: "center" },
//     { title: "Operation Name", dataIndex: "op_name", align: "center" },
//     { title: "Operation Count", dataIndex: "operation_count", align: "center" },
//   ];

//   return (
//     <div style={{ background: "#f6f8fa", minHeight: "100vh", padding: "30px" }}>
//       {/* 🔹 Centered Filters */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: "20px",
//           flexWrap: "wrap",
//           background: "#fff",
//           padding: "20px 30px",
//           borderRadius: "10px",
//           boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
//         }}
//       >
//         <div style={{ minWidth: 200 }}>
//           <label style={labelStyle}>Select Line</label>
//           <Select
//             placeholder="Select Line"
//             style={{ width: "100%" }}
//             value={line}
//             onChange={setLine}
//             loading={!lines.length}
//           >
//             {lines.map((ln) => (
//               <Option key={ln} value={ln}>
//                 {ln}
//               </Option>
//             ))}
//           </Select>
//         </div>

//         <div style={{ minWidth: 250 }}>
//           <label style={labelStyle}>Select Operation</label>
//           <Select
//             placeholder="Select Operation"
//             style={{ width: "100%" }}
//             value={operation}
//             onChange={setOperation}
//             loading={!operations.length}
//             showSearch
//             optionFilterProp="children"
//             allowClear
//           >
//             {operations.map((op) => (
//               <Option key={op.op_id} value={op.op_id}>
//                 {op.op_name}
//               </Option>
//             ))}
//           </Select>
//         </div>

//         <div style={{ minWidth: 120, marginTop: 26 }}>
//           <Button
//             type="primary"
//             icon={<SendOutlined />}
//             loading={loading}
//             onClick={handleLoad}
//             style={{
//               background: "#2150FDFF",
//               border: "none",
//               width: "100%",
//             }}
//           >
//             Load
//           </Button>
//         </div>
//       </div>

//       {/* 🔹 Centered Produced & Target Cards */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: "40px",
//           marginTop: 40,
//           flexWrap: "wrap",
//         }}
//       >
//         <Card style={cardStyle} bodyStyle={{ padding: "20px 30px" }}>
//           <Title level={5} style={cardTitle}>
//             Produced Pcs
//           </Title>
//           <Title level={1} style={{ color: "#1890ff", margin: 0 }}>
//             {produced}
//           </Title>
//         </Card>

//         <Card style={cardStyle} bodyStyle={{ padding: "20px 30px" }}>
//           <Title level={5} style={cardTitle}>
//             Target Pcs
//           </Title>
//           <Title level={1} style={{ color: "#52c41a", margin: 0 }}>
//             {target}
//           </Title>
//         </Card>
//       </div>

//       {/* 🔹 Table */}
//       <div
//         style={{
//           background: "#fff",
//           marginTop: 40,
//           borderRadius: 8,
//           padding: 20,
//           boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
//         }}
//       >
//         <Spin spinning={loading}>
//           <Table
//             dataSource={tableData}
//             columns={columns}
//             pagination={false}
//             bordered
//             rowKey="com_id"
//           />
//         </Spin>
//       </div>
//     </div>
//   );
// };

// const labelStyle = { display: "block", fontWeight: 600, marginBottom: 5 };
// const cardStyle = {
//   background: "#fff",
//   borderRadius: 10,
//   boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//   textAlign: "center",
//   minWidth: 220,
// };
// const cardTitle = {
//   color: "#555",
//   fontWeight: 600,
//   marginBottom: 10,
//   textTransform: "uppercase",
// };

// export default HourlyProductionReport;
import React, { useState, useEffect } from "react";
import { Select, Button, Card, Typography, Table, message, Spin } from "antd";
import { SendOutlined } from "@ant-design/icons";
import ApiService from "../EOLReportApi/ReportApiService";
import "antd/dist/reset.css";

const { Option } = Select;
const { Title } = Typography;

const HourlyProductionReport = () => {
  const [lines, setLines] = useState([]);
  const [operations, setOperations] = useState([]);
  const [line, setLine] = useState("");
  const [operation, setOperation] = useState("");
  const [produced, setProduced] = useState(0);
  const [target, setTarget] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔹 Fetch dropdown data on mount
  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const lineData = await ApiService.getLines();
        const operationData = await ApiService.getOperations();
        setLines(lineData);
        setOperations(operationData);
      } catch (err) {
        message.error("Error loading dropdown data");
        console.error(err);
      }
    };
    fetchDropdowns();
  }, []);

  // 🔹 Fetch report data
  const fetchReportData = async () => {
    if (!line) return;

    setLoading(true);
    try {
      const res = operation
        ? await ApiService.getMasterOperationsCount(line, operation)
        : await ApiService.getMasterOperationsCount(line);

      if (res && res.status) {
        const summary = res.data?.summary;
        const stats = summary?.line_statistics?.[line];

        if (stats) {
          setProduced(stats["producedPCS(device_id)"] || 0);
          setTarget(stats["target_pcs"] || 0); // ✅ show target_pcs instead of count
          setTableData(res.data?.master_operations || []);
        } else {
          setProduced(0);
          setTarget(0);
          setTableData([]);
          message.info("No data found for this line.");
        }
      } else {
        message.error("No data found for selected filters.");
      }
    } catch (err) {
      console.error("Error loading data:", err);
      message.error("Failed to load data.");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Auto-refresh every 5 seconds once a line is selected
  useEffect(() => {
    if (!line) return;

    // Run immediately once
    fetchReportData();

    // Then repeat every 5 seconds
    const interval = setInterval(() => {
      fetchReportData();
    }, 5000);

    // Cleanup interval on unmount or when line/operation changes
    return () => clearInterval(interval);
  }, [line, operation]);

  // 🔹 Manual Load Button
  const handleLoad = () => {
    if (!line) {
      message.warning("Please select a Line!");
      return;
    }
    fetchReportData();
  };

  // 🔹 Table Columns
  const columns = [
    { title: "Device ID", dataIndex: "device_id", align: "center" },
    { title: "Operation Name", dataIndex: "op_name", align: "center" },
    {
      title: "Target Pcs",
      dataIndex: "target_pcs",
      align: "center",
      render: (text) => text || 0,
    },
    {
      title: "Operation Count",
      dataIndex: "operation_count",
      align: "center",
      render: (text) => text || 0,
    },
  ];

  return (
    <div style={{ background: "#f6f8fa", minHeight: "100vh", padding: "30px" }}>
      {/* 🔹 Filters */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
          flexWrap: "wrap",
          background: "#fff",
          padding: "20px 30px",
          borderRadius: "10px",
          boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ minWidth: 200 }}>
          <label style={labelStyle}>Select Line</label>
          <Select
            placeholder="Select Line"
            style={{ width: "100%" }}
            value={line}
            onChange={setLine}
            loading={!lines.length}
          >
            {lines.map((ln) => (
              <Option key={ln} value={ln}>
                {ln}
              </Option>
            ))}
          </Select>
        </div>

        <div style={{ minWidth: 250 }}>
          <label style={labelStyle}>Select Operation</label>
          <Select
            placeholder="Select Operation"
            style={{ width: "100%" }}
            value={operation}
            onChange={setOperation}
            loading={!operations.length}
            showSearch
            optionFilterProp="children"
            allowClear
          >
            {operations.map((op) => (
              <Option key={op.op_id} value={op.op_id}>
                {op.op_name}
              </Option>
            ))}
          </Select>
        </div>

        <div style={{ minWidth: 120, marginTop: 26 }}>
          <Button
            type="primary"
            icon={<SendOutlined />}
            loading={loading}
            onClick={handleLoad}
            style={{
              background: "#2150FDFF",
              border: "none",
              width: "100%",
            }}
          >
            Load
          </Button>
        </div>
      </div>

      {/* 🔹 Produced & Target Cards */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "40px",
          marginTop: 40,
          flexWrap: "wrap",
        }}
      >
        <Card style={cardStyle} bodyStyle={{ padding: "20px 30px" }}>
          <Title level={5} style={cardTitle}>
            Produced Pcs
          </Title>
          <Title level={1} style={{ color: "#1890ff", margin: 0 }}>
            {produced}
          </Title>
        </Card>

        <Card style={cardStyle} bodyStyle={{ padding: "20px 30px" }}>
          <Title level={5} style={cardTitle}>
            Target Pcs
          </Title>
          <Title level={1} style={{ color: "#52c41a", margin: 0 }}>
            {target}
          </Title>
        </Card>
      </div>

      {/* 🔹 Table */}
      <div
        style={{
          background: "#fff",
          marginTop: 40,
          borderRadius: 8,
          padding: 20,
          boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Spin spinning={loading}>
          <Table
            dataSource={tableData}
            columns={columns}
            pagination={false}
            bordered
            rowKey="com_id"
          />
        </Spin>
      </div>
    </div>
  );
};

const labelStyle = { display: "block", fontWeight: 600, marginBottom: 5 };
const cardStyle = {
  background: "#fff",
  borderRadius: 10,
  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  textAlign: "center",
  minWidth: 220,
};
const cardTitle = {
  color: "#555",
  fontWeight: 600,
  marginBottom: 10,
  textTransform: "uppercase",
};

export default HourlyProductionReport;
